import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setup"
    }}>{`Setup`}</h1>
    <p><inlineCode parentName="p">{`Go to Dashboard > Inventory -> Add New/Edit > Seasonal Pricing -> Add Seasons`}</inlineCode></p>
    <p><img alt="Seasonal date range" src={require("./images/date-range.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      